// src/components/Layout/PageContainer.js
import styled from "styled-components";

export const PageContainer = styled.main`
  //max-width: 1368px;              /* szerokość jak na projekcie */
  //margin: 0 auto;                 /* wycentrowanie */
  //padding: 24px 16px 40px 16px;   /* odstępy od krawędzi */
  padding-bottom: 80px;

`;
